import app from 'flarum/forum/app';
import { override, extend } from 'flarum/common/extend';
import UserSecurityPage from 'flarum/forum/components/UserSecurityPage';
import LabelValue from 'flarum/common/components/LabelValue';
import humanTime from 'flarum/common/utils/humanTime';
import IPAddress from 'flarum/forum/components/IPAddress';
import AccessTokensList from 'flarum/forum/components/AccessTokensList';

app.initializers.add('kemze-kemoverse', () => {

	// Remove the "New Token" button
	extend(UserSecurityPage.prototype, 'developerTokensItems', function (items) {
		items.remove('newAccessToken');
		const list = items.get('accessTokenList');
		if (list) {
			list.attrs.icon = 'fas fa-paw'; // any FA icon
		}
	});

	extend(AccessTokensList.prototype, 'tokenActionItems', function (items) {
		if (this.attrs.type === 'developer_token') {
			items.remove('toggleDisplay');
		}
	});

	extend(AccessTokensList.prototype, 'tokenInfoItems', function (items, token) {
		if (this.attrs.type !== 'developer_token') return;

		items.remove('lastActivityAt');

		items.add('lastActivityAt',

			<div className="AccessTokensList-item-lastActivityAt">
			<LabelValue
			label={app.translator.trans('core.forum.security.last_activity')}
			value={
				token.lastActivityAt() ? (
					<>
					{humanTime(token.lastActivityAt())}
					{token.lastIpAddress() && (
						<span> — <IPAddress ip={token.lastIpAddress()} /></span>
					)}
					<span> — Kemoverse</span>
					</>
				) : (
					app.translator.trans('core.forum.security.never')
				)
			}
			/>
			</div>
		);
	});
	extend(AccessTokensList.prototype, 'tokenViewItems', function (items, token) {
		if (this.attrs.type !== 'developer_token') return;

		const avatar = token.attribute('characterAvatar');
		if (!avatar) return;

		console.log(avatar);
		items.replace(
			'icon',
			<div className="AccessTokensList-item-icon">
			<img src={avatar} style={{ width: '64px', height: '64px', borderRadius: '25%' }} />
			</div>
		);
	});

	override(AccessTokensList.prototype, 'generateTokenTitle', function (original, token) {
		if (this.attrs.type === 'developer_token') {
			return token.title() || app.translator.trans('core.forum.security.token_title_placeholder');
		}
		return original(token);
	});
	// Rename the heading
	override(UserSecurityPage.prototype, 'settingsItems', function (original) {
		const items = original();
		if (items.has('developerTokens')) {
			const fieldset = items.get('developerTokens');
			if (fieldset) {
				fieldset.attrs.label = 'Kemoverse Characters';
			}
		}
		return items;
	});

});
